var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero'),_c('Why'),_c('FeaturedMovies'),_c('FeaturedTVShows'),_c('BlogSection'),_c('CityDorms'),_c('Media')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }